export const metrikaCounterEditorInitialData = {
    isOpen: false,
    markMetrikaLinks: false,
    errors: []
};

export const metrikaCounterEditorInitialValue = {
    counters: undefined,
    markMetrikaLinks: false
};

export const formatMetrikaCountersValue = (counters: string[]): string => {
    return counters.join(', ');
};
